import { doc, getDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { Project } from '../../../hooks/useProjects';
import { db } from '../../../lib/firebase';

export async function getProjectById(projectId: string, t: (key: string) => string): Promise<Project | null> {
  try {
    const projectRef = doc(db, 'projects', projectId);
    const projectDoc = await getDoc(projectRef);
    
    if (!projectDoc.exists()) {
      return null;
    }
    
    const data = projectDoc.data();
    return {
      id: projectDoc.id,
      projectName: data.projectName || '',
      projectDescription: data.projectDescription || '',
      companyId: data.companyId || '',
      ...data
    } as Project;
  } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('❌ getProjectById: Error fetching project:', error);
      }
    throw error;
  }
}

export async function updateProject(
  projectId: string,
  data: {
    projectName: string;
    projectDescription: string;
    companyId: string;
  }
): Promise<void> {
  try {
    const projectRef = doc(db, 'projects', projectId);
    
    await updateDoc(projectRef, {
      projectName: data.projectName,
      projectDescription: data.projectDescription,
      companyId: data.companyId
    });
  } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('❌ updateProject: Error updating project:', error);
      }
    throw error;
  }
}

export async function deleteProject(projectId: string): Promise<void> {
  try {
    const projectRef = doc(db, 'projects', projectId);
    
    await deleteDoc(projectRef);
  } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('❌ deleteProject: Error deleting project:', error);
      }
    throw error;
  }
}

